import clsx from "clsx";
import { MediaMobile, MediaTablet } from "../../../api/const/MediaQuery";
import useMediaQuery from "../../../hook/useMediaQuery";
import "./BillingsAccordion.css";
import { BillingsAccordionBody } from "./BillingsAccordionBody";
import { BillingListData } from "components/types/types";




interface iBillingsAccordion {
  data: BillingListData[] | undefined
}



export const BillingsAccordion = ({ data }: iBillingsAccordion) => {
const tablet = useMediaQuery(MediaTablet)
const mobile = useMediaQuery(MediaMobile)

  return (

    <div className="d-flex  w-100 flex-column tableContainer mb-5 ">
      <div className="d-flex  p-0 m-0  dtext-uppercase flex-row tHead tablePadding">
        <p className={clsx("p-0 m-0",
        { "w-85 ps-3":!tablet},
        {"w-70" :tablet})}>Month</p>
        <p className={clsx(" p-0 m-0 ",
        { "w-15 pe-3 tae": !tablet &&  !mobile},
        {"w-30 tae pe-5 " : tablet && !mobile},
        {"w-30 tas ps-3" : tablet && mobile})}>Plan</p>
      </div>
      <BillingsAccordionBody data={data} />
    </div>


  );
}

